import Users from "../components/Users/Users";
import User from "../components/Users/User";
import {PERM} from "../utilites/permissions";

const users = [
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: {requiresAuth: true,
      permissions: [
        PERM.USER,
      ]
    },
    props: true,
  },
  {
    path: '/users/new',
    name: 'UserAdd',
    component: User,
    meta: {requiresAuth: true,
      permissions: [
        PERM.USER,
        PERM.USER_EDIT,
      ]
    },
    props: true
  },
  {
    path: '/users/edit/:user_id',
    name: 'UserEdit',
    component: User,
    meta: {requiresAuth: true,
      permissions: [
        PERM.USER,
        PERM.USER_EDIT,
      ]
    },
    props: true
  },
];

export default users;



// WEBPACK FOOTER //
// ./src/router/users.js